import { AskResponse, Citation } from '@/models'
import { cloneDeep } from 'lodash-es'

type ParsedAnswer = {
    citations: Citation[]
    markdownFormatText: string
}

export function parseAnswer(answer: AskResponse): ParsedAnswer {
    let answerText = answer.answer

    // 1. Protect fenced code blocks before any text transformations
    // This prevents citation replacement and list-spacing from mangling
    // content inside code blocks.
    const codeBlocks: string[] = []
    const codeFenceRegex = /```[\s\S]*?```/g
    answerText = answerText.replace(codeFenceRegex, (match) => {
        const token = `{{CODE_BLOCK_${codeBlocks.length}}}`
        codeBlocks.push(match)
        return token
    })

    //2. Citation replacement (runs only on non-code-block text)
    const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g)

    const lengthDocN = '[doc'.length

    const filteredCitations: Citation[] = []
    let citationReindex = 0
    citationLinks?.forEach((link) => {
        // Replacing the links/citations with number
        const citationIndex = link.slice(lengthDocN, link.length - 1)
        const citation = cloneDeep(answer.citations[Number(citationIndex) - 1])
        if (citation && !filteredCitations.find((c) => c.id === citationIndex)) {
            answerText = answerText.replaceAll(link, `^${++citationReindex}^`)
            citation.id = citationIndex // original doc index to de-dupe
            citation.reindex_id = citationReindex.toString() // reindex from 1 for display
            filteredCitations.push(citation)
        }
    })

    // ── 3. List-item spacing ──
    // Add blank line before list items if not already present
    answerText = answerText.replace(/([^\n])\n([-*+] )/g, '$1\n\n$2')
    // Remove all double newlines that are followed by a list marker
    // This will collapse blank lines between any list items
    answerText = answerText.replace(/\n\n+([-*+] )/g, '\n$1')

    // ── 4. Restore code blocks ──
    codeBlocks.forEach((block, index) => {
        answerText = answerText.replace(`{{CODE_BLOCK_${index}}}`, block)
    })

    return {
        citations: filteredCitations,
        markdownFormatText: answerText,
    }
}
